import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DeleteCollection.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function DeleteCollection() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editingCollection, setEditingCollection] = useState(null); // Store the collection being edited
  const [updatedName, setUpdatedName] = useState("");
  const [updatedDescription, setUpdatedDescription] = useState("");
  const [updatedImage, setUpdatedImage] = useState(null);

  // Fetch collections from the API
  const fetchCollections = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://api.swasthmitra.com/api/collections/get"
      );
      setCollections(response.data.collections);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching collections:", err);
      setError("Failed to fetch collections. Please try again later.");
      setLoading(false);
    }
  };

  // Delete collection by ID
  const deleteCollection = async (id) => {
    if (window.confirm("Are you sure you want to delete this collection?")) {
      try {
        await axios.delete(
          `https://api.swasthmitra.com/api/collections/delete/${id}`
        );
        toast.success("Collection deleted successfully!");

        fetchCollections(); // Refresh the collection list after deletion
      } catch (err) {
        // console.error("Error deleting collection:", err);
        toast.error("Failed to delete the collection. Please try again.");
      }
    }
  };

  // Open edit modal with current collection data
  const openEditModal = (collection) => {
    setEditingCollection(collection);
    setUpdatedName(collection.name);
    setUpdatedDescription(collection.description);
    setUpdatedImage(null); // Reset image input
  };

  // Handle the update of collection data
  const handleUpdateCollection = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", updatedName);
    formData.append("description", updatedDescription);
    if (updatedImage) formData.append("image", updatedImage);

    try {
      console.log(formData.name);
      await axios.put(
        `https://api.swasthmitra.com/api/collections/update/${editingCollection._id}`,
        {
          name: updatedName,
          description: updatedDescription,
          image: updatedImage,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Collection updated successfully!");
      setEditingCollection(null); // Close the modal
      fetchCollections(); // Refresh the collection list after update
    } catch (err) {
      console.error("Error updating collection:", err);
      toast.error("Failed to update the collection. Please try again.");
    }
  };

  useEffect(() => {
    fetchCollections();
  }, []);

  if (loading) return <p>Loading collections...</p>;
  if (error) return <p>{error}</p>;

  return (
    <>
      <div className="delete-slider-container">
        <h2>Manage Collections</h2>
        {collections.length === 0 ? (
          <p>No collections found.</p>
        ) : (
          <table className="slider-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {collections.map((collection) => (
                <tr key={collection._id}>
                  <td>{collection.name}</td>
                  <td>{collection.description}</td>
                  <td>
                    <img
                      src={collection.imageUrl}
                      alt={collection.name}
                      style={{ width: "100px", height: "50px" }}
                    />
                  </td>
                  <td>
                    <div className="action-btns">
                      <button
                        className="edit-btn"
                        onClick={() => openEditModal(collection)}
                      >
                        Edit
                      </button>
                      <button
                        className="delete-btn"
                        onClick={() => deleteCollection(collection._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Modal for editing collection */}
        {editingCollection && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Edit Collection</h3>
              <form onSubmit={handleUpdateCollection}>
                <div>
                  <label>Name</label>
                  <input
                    type="text"
                    value={updatedName}
                    onChange={(e) => setUpdatedName(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label>Description</label>
                  <textarea
                    value={updatedDescription}
                    onChange={(e) => setUpdatedDescription(e.target.value)}
                    required
                  ></textarea>
                </div>
                <div>
                  <label>Image</label>
                  <input
                    type="file"
                    onChange={(e) => setUpdatedImage(e.target.files[0])}
                  />
                </div>
                <div className="action-btns">
                  <button type="submit">Update</button>
                  <button
                    type="button"
                    onClick={() => setEditingCollection(null)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DeleteCollection;
